// Pipeline-First Constants — Soulful Places Workflow

export const PIPELINE_STATUSES = [
  "discover", "shortlist", "listed", "contacted",
  "call", "proposal", "negotiation", "won", "lost"
];

export const PIPELINE_STATUS_LABELS = {
  discover: "Discover", shortlist: "Shortlist",
  listed: "Listed", contacted: "Contacted",
  call: "Call", proposal: "Proposal",
  negotiation: "Negotiation", won: "Won", lost: "Lost"
};

export const PIPELINE_STATUS_COLORS = {
  discover: "bg-slate-500/15 text-slate-400",
  shortlist: "bg-violet-500/15 text-violet-400",
  listed: "bg-cyan-500/15 text-cyan-400",
  contacted: "bg-sky-500/15 text-sky-400",
  call: "bg-amber-500/15 text-amber-400",
  proposal: "bg-orange-500/15 text-orange-400",
  negotiation: "bg-pink-500/15 text-pink-400",
  won: "bg-green-500/15 text-green-400",
  lost: "bg-red-500/15 text-red-400"
};

export const PIPELINE_DOT_COLORS = {
  discover: "#64748B", shortlist: "#8B5CF6",
  listed: "#06B6D4", contacted: "#0EA5E9",
  call: "#F59E0B", proposal: "#F97316",
  negotiation: "#EC4899", won: "#22C55E", lost: "#EF4444"
};

// Legacy aliases
export const DEAL_STATUSES = PIPELINE_STATUSES;
export const DEAL_STATUS_LABELS = PIPELINE_STATUS_LABELS;
export const DEAL_STATUS_COLORS = PIPELINE_STATUS_COLORS;
export const DEAL_STATUS_DOT_COLORS = PIPELINE_DOT_COLORS;

export const PRIORITIES = ["low", "medium", "high", "urgent"];
export const PRIORITY_LABELS = { low: "Low", medium: "Medium", high: "High", urgent: "Urgent" };
export const PRIORITY_COLORS = { low: "text-white/40", medium: "text-blue-400", high: "text-orange-400", urgent: "text-red-400" };

export const COMPANY_STATUSES = [
  "discovered", "qualified", "in_conversation", "proposal_phase",
  "partner_pending", "active_partner", "paused", "churned", "disqualified"
];
export const COMPANY_STATUS_LABELS = {
  discovered: "Discovered", qualified: "Qualified",
  in_conversation: "In Conversation", proposal_phase: "Proposal Phase",
  partner_pending: "Partner Pending", active_partner: "Active Partner",
  paused: "Paused", churned: "Churned", disqualified: "Disqualified"
};
export const COMPANY_STATUS_COLORS = {
  discovered: "bg-slate-500/15 text-slate-400",
  qualified: "bg-violet-500/15 text-violet-400",
  in_conversation: "bg-cyan-500/15 text-cyan-400",
  proposal_phase: "bg-amber-500/15 text-amber-400",
  partner_pending: "bg-orange-500/15 text-orange-400",
  active_partner: "bg-green-500/15 text-green-400",
  paused: "bg-yellow-500/15 text-yellow-400",
  churned: "bg-red-500/15 text-red-400",
  disqualified: "bg-red-500/15 text-red-300"
};

export const ACTIVITY_TYPES = ["note", "call", "email", "meeting"];

// Contact Sources
export const CONTACT_SOURCES = ["manual", "website", "referral", "linkedin", "conference", "other"];
export const CONTACT_SOURCE_LABELS = {
  manual: "Manual", website: "Website", referral: "Referral",
  linkedin: "LinkedIn", conference: "Conference", other: "Other"
};
